class UrlManager {
    setUrlParam = (param, value) => {
        let url = new URL(window.location);
        url.searchParams.set(param, value); 
        window.history.replaceState({}, '', url); 
    };

    removeUrlParam = (param) => {
        let url = new URL(window.location);
        url.searchParams.delete(param); 
        window.history.replaceState({}, '', url); 
    };

    getUrlParam = (param) => {
        const searchParams = new URLSearchParams(window.location.search);
        return searchParams.get(param);
    };

    setPath = (path) => {
        const newUrl = path + window.location.search; 
        history.pushState(null, '', newUrl);
    }

    setUrl = (url) => {
        history.pushState(null, '', url);
    }
}

export { UrlManager };
